import { ILookUpType } from "../models/generic/lookup-type/lookup-type.model";

export const onlyUnique = (arr: ILookUpType[]): ILookUpType[] => {
    const output: ILookUpType[] = [];
    const clone = [...arr] as ILookUpType[];
    arr.forEach(x => {
        if (!output.filter(o => o.id === x.id).length) {
            output.push(x);
        }
    });
    return output;
}